import { useEffect, useRef } from "react";
import SplitType from "split-type";
import gsap from "gsap";

//Assets
import timeLine1Img from "@/assets/timeline/timeline-1.png";
import timeLine2Img from "@/assets/timeline/timeline-2.png";
import timeLine3Img from "@/assets/timeline/timeline-3.png";
import timeLine4Img from "@/assets/timeline/timeline-4.png";
import timeLine5Img from "@/assets/timeline/timeline-5.png";
import Aboutbg from "@/assets/Aboutbg.png";
import whatsappicon from "@/assets/icons8-whatsapp-50.png";
import Homegirl from "@/assets/Homegirl.png";
import ourmission from "@/assets/ourmission.png";
import ourvision from "@/assets/ourvision.png";
import Whyus from "@/assets/Whyus.png";

export default function AboutPage() {
  const textRef = useRef(null);
  const textRef2 = useRef(null);

  // SEO Meta Tags Setup
  useEffect(() => {
    // Set page title
    document.title = "About Oaktree Financial Services - Certified Financial Planner & Investment Advisor Mumbai";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Learn about Oaktree Financial Services - Mumbai's trusted certified financial planner since 2008. Expert wealth management, retirement planning, and investment advisory services with personalized financial guidance.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Learn about Oaktree Financial Services - Mumbai's trusted certified financial planner since 2008. Expert wealth management, retirement planning, and investment advisory services with personalized financial guidance.";
      document.head.appendChild(meta);
    }

    // Meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", "about Oaktree financial services, certified financial planner Mumbai, CFP Mumbai, financial advisor background, wealth management company Mumbai, investment advisory firm, financial planning company Mumbai, retirement planning expert, portfolio manager Mumbai");
    } else {
      const meta = document.createElement('meta');
      meta.name = "keywords";
      meta.content = "about Oaktree financial services, certified financial planner Mumbai, CFP Mumbai, financial advisor background, wealth management company Mumbai, investment advisory firm, financial planning company Mumbai, retirement planning expert, portfolio manager Mumbai";
      document.head.appendChild(meta);
    }

    // Open Graph Meta Tags
    const ogTags = [
      { property: "og:title", content: "About Oaktree Financial Services - Certified Financial Planner Mumbai" },
      { property: "og:description", content: "Trusted financial planning and wealth management services in Mumbai since 2008. Certified financial advisor helping individuals and families achieve financial freedom." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.oaktree.in/about-us" },
    ];

    ogTags.forEach(tag => {
      let ogMeta = document.querySelector(`meta[property="${tag.property}"]`);
      if (ogMeta) {
        ogMeta.setAttribute("content", tag.content);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute("property", tag.property);
        meta.content = tag.content;
        document.head.appendChild(meta);
      }
    });

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", "https://www.oaktree.in/about-us");
    } else {
      const link = document.createElement('link');
      link.rel = "canonical";
      link.href = "https://www.oaktree.in/about-us";
      document.head.appendChild(link);
    }

    // Structured Data for About Page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About Oaktree Financial Services",
      "description": "Learn about Oaktree Financial Services, Mumbai's trusted certified financial planner since 2008",
      "mainEntity": {
        "@type": "FinancialService",
        "name": "Oaktree Financial Services",
        "founder": {
          "@type": "Person",
          "name": "Uma",
          "jobTitle": "Certified Financial Planner"
        },
        "foundingDate": "2008",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "160 Powai Plaza Hiranandani Business Park Powai",
          "addressLocality": "Mumbai",
          "postalCode": "400076",
          "addressCountry": "IN"
        }
      }
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (script) {
      script.textContent = JSON.stringify(structuredData);
    } else {
      const newScript = document.createElement('script');
      newScript.type = "application/ld+json";
      newScript.textContent = JSON.stringify(structuredData);
      document.head.appendChild(newScript);
    }
  }, []);

  const timelineItems = [
    {
      text: "I've been helping people manage money since 1995, started with tailored financial product recommendations.",
      image: timeLine1Img,
    },
    {
      text: "In 2008, I became a Certified Financial Planner and founded Oaktree.",
      image: timeLine2Img,
    },
    {
      text: "I believe that a sound financial plan brings confidence, satisfaction, and a life full of wealth.",
      image: timeLine3Img,
    },
    {
      text: "Oaktree provides step-by-step guidance in investments, insurance, retirement, taxes, and estate planning.",
      image: timeLine4Img,
    },
    {
      text: "At Oaktree, we make financial planning stress-free, helping you achieve your dreams and secure your future.",
      image: timeLine5Img,
    },
  ];

  return (
    <div>
      <header
        className="relative bg-cover bg-center h-screen text-white"
        style={{
          backgroundImage: `url(${Aboutbg})`,
        }}
      >
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h1 className="text-3xl lg:text-7xl font-bold text-[#78A742]">
            Empowering You with <br /> Financial Clarity
          </h1>
          <p className="mt-4 text-black text-lg lg:text-2xl max-w-xl">
            At Oaktree, we help individuals and families build strong financial
            foundations through expert-driven planning and personalized
            guidance.
          </p>
          <a
            href="https://wa.me/919892147989"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed z-[9999] bottom-6 right-4 sm:bottom-8 sm:right-8 bg-green-600 hover:bg-green-700 text-black font-bold text-lg px-5 py-2 rounded-full flex items-center space-x-2 shadow-md"
            aria-label="Chat with certified financial planner on WhatsApp"
          >
            <span>Chat Now</span>
            <img src={whatsappicon} className="w-8" alt="WhatsApp contact" />
          </a>
        </div>
      </header>

      <section className="mb-0 lg:my-20 px-5 lg:px-20 md:flex md:justify-between flex-wrap lg:flex-nowrap">
        <div className="h-auto mb-8 lg:mb-0 lg:h-[80svh] w-full lg:w-[40vw] ">
          <img className="h-full w-full object-contain" src={Homegirl} alt="Professional certified financial planner in Mumbai" />
        </div>

        <div className="md:w-1/2 text-left flex flex-col justify-center">
          <h2 className="text-3xl lg:text-6xl md:text-[65px] font-bold text-[#78A742] mb-3 lg:mb-8">
            Why Choose Oaktree?
          </h2>
          <p className="text-black text-sm lg:text-3xl mb-6 lg:mb-0">
            At Oaktree, we believe financial confidence comes from clarity,
            strategy, and support. Just like the mighty oak, we stand strong for
            our clients; offering dependable financial planning services that
            help individuals and families grow with purpose, security, and peace
            of mind.
          </p>
        </div>
      </section>

      <section className="relative bg-white py-16 px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-16">
          Our Story - How It All Began
        </h2>

        {/* Vertical Line */}
        <div className="timeline">
          <div className="timeline-line"></div>

          <div className="relative flex flex-col space-y-16">
            {timelineItems.map((item, index) => (
              <article
                key={index}
                className={`relative flex flex-col md:flex-row mb-0 ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                } items-center md:justify-between`}
              >
                <div className="timeline-number"></div>
                {/* Image */}
                <div className="w-full md:w-5/12 flex justify-center mb-8 md:mb-0">
                  <img
                    src={item.image}
                    alt={`Oaktree financial planning milestone ${index + 1}`}
                    className="w-60 md:w-96 h-auto object-cover"
                  />
                </div>

                {/* Circle and Text */}
                <div className="mb-10 md:mb-0 w-full md:w-5/12 flex flex-col items-center md:items-start relative">
                  <div className="bg-[#92cd4d] text-lg md:text-3xl text-black p-6 rounded-lg shadow-lg w-full">
                    {item.text}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-[#0097B2] to-[#7ED957] py-18 px-3 sm:px-18 lg:px-49 max-w-full mx-auto space-y-12">
        {/* Mission Card */}
        <article className="bg-white p-5 lg:pt-10 lg:pr-10 lg:pl-0 lg:pb-0 rounded-4xl flex flex-col lg:flex-row items-center shadow-lg">
          {/* Left Side */}
          <div className="w-full lg:w-1/2 text-left ">
            <h2 className="text-4xl lg:text-8xl font-bold bg-gradient-to-r pl-0 lg:pl-10 from-[#00BF63] via-[#00592E] to-[#000000] bg-clip-text text-transparent">
              Our <span className="block">Mission</span>
            </h2>
            <div className="mt-6">
              <img
                src={ourmission}
                alt="Oaktree financial services mission"
                className="hidden lg:block w-96 relative"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 mt-6 md:mt-0">
            <p
              ref={textRef}
              className="text-lg lg:text-4xl text-black font-medium "
            >
              At Oaktree, we believe that financial planning is not
              just about numbers, but about creating the freedom to live your
              dreams. We guide you with care, helping you navigate life's
              milestones, so you can enjoy a secure and fulfilling future.
            </p>
          </div>
        </article>

        {/* Vision Card */}
        <article className="bg-white lg:pl-10 p-5 rounded-4xl flex flex-col-reverse md:flex-row gap-6 items-center shadow-lg mt-10 lg:mt-24">
          <div className="md:w-1/2 mt-0 lg:mt-6 md:mt-0">
            <p
              ref={textRef2}
              className="text-lg lg:text-4xl text-black font-medium "
            >
              To empower individuals worldwide with personalized financial
              guidance, we envision a world where everyone achieves their dreams
              with clarity, confidence, and financial freedom.
            </p>
          </div>

          {/* Left Side */}
          <div className="w-full md:w-1/2 text-left">
            <h3 className="text-4xl lg:text-8xl font-bold bg-gradient-to-r from-[#00BF63] via-[#00592E] to-[#000000] bg-clip-text text-transparent">
              Our <span className="block">Vision</span>
            </h3>
            <div className="mt-6 justify-items-end">
              <img
                src={ourvision}
                alt="Oaktree financial services vision"
                className="w-40 md:w-96 relative md:justify-items-end"
              />
            </div>
          </div>
        </article>
      </section>

      <section className="bg-white py-12 px-4 sm:px-8 max-w-7xl mx-auto">
        <h2 className="text-5xl sm:text-6xl font-bold text-center text-[#78A742] mb-10">
          Why us?
        </h2>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <img
            src={Whyus}
            alt="Personalized financial advisory services Mumbai"
            className="rounded-lg shadow-md w-full object-cover"
          />
          <ul className="list-disc pl-5 text-black font-bold space-y-4 text-xl sm:text-2xl">
            <li>Personalised investment advisory</li>
            <li>Financial assets consolidation in one place</li>
            <li>Dedicated team and relationship manager for you</li>
            <li>Seamless and quick execution of investment</li>
            <li>Web and mobile access to your investment portfolio</li>
            <li>Monthly portfolio updates via email</li>
            <li>Periodic goal progress report</li>
          </ul>
        </div>
      </section>
    </div>
  );
}